'use client';

import type { ComponentProps, CSSProperties, HTMLAttributes, PropsWithChildren } from 'react';
import { VpLoader } from '@vtmn-play/react/headless';
import classNames from 'classnames';

interface ILoaderProps {
  size?: 'small' | 'medium' | 'large' | 'extra-large';
  overlay?: boolean;
  loading?: boolean;
  centered?: boolean;
  inverted?: boolean;
  style?: CSSProperties;
}

export const Loader = ({
  size = 'small',
  loading = true,
  children,
  centered = false,
  inverted = false,
  style,
  overlay = false,
}: PropsWithChildren<ILoaderProps>) => {
  const styles = style && { style: { ...style } };
  return (
    <div
      data-testid="loader"
      className={classNames('loader', {
        'loader--overlay': overlay,
        'loader--inverted': inverted,
        'loader--centered': centered,
        'loader--nesting': children,
        'loader--loading': loading,
      })}
      {...(styles as HTMLAttributes<HTMLDivElement>)}
    >
      {children && (
        <div className="loader__nested-content">
          {children}
        </div>
      )}
      {loading && (
        <span data-testid="PageLoader" className="loader__icon">
          <VpLoader size={size} />
        </span>
      )}
    </div>
  );
};

export const MainLoader = ({ size = 'large', ...rest }: ComponentProps<typeof VpLoader>) => (
  <div className="main-loader" data-testid="main-loader">
    <VpLoader size={size} {...rest} />
  </div>
);
